var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "matchDetail" },
    [
      _c("Header"),
      _vm._v(" "),
      _c("div", { staticClass: "matchContent" }, [
        _c(
          "div",
          { staticClass: "matchContent_title" },
          [
            _c(
              "el-carousel",
              { attrs: { trigger: "click" } },
              _vm._l(_vm.matchData.pictureList, function (item) {
                return _c("el-carousel-item", { key: item }, [
                  _c("img", {
                    staticStyle: { width: "100%" },
                    attrs: { src: item, alt: "" },
                  }),
                ])
              }),
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "matchContent_tab" }, [
              _c(
                "div",
                { staticClass: "container matchContent_tab_box" },
                [
                  _vm._l(_vm.tabList, function (item, index) {
                    return [
                      _vm.matchData[item.name] ||
                      item.name == "works" ||
                      item.name == "upload"
                        ? _c(
                            "div",
                            {
                              key: index,
                              class:
                                _vm.tabActive == item.text
                                  ? "matchContent_tab_item active"
                                  : "matchContent_tab_item",
                              on: {
                                click: function ($event) {
                                  return _vm.changeTab(item.text)
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "icon_box" }, [
                                _c("img", {
                                  attrs: { src: item.icon, alt: "" },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(item.text))]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "container matchContent_content" }, [
          _c("span", { staticClass: "matchContent_content_title" }, [
            _vm._v(_vm._s(`- ${_vm.tabActive} -`)),
          ]),
          _vm._v(" "),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tabActive == "报名通道",
                expression: "tabActive == '报名通道'",
              },
            ],
            domProps: { innerHTML: _vm._s(_vm.matchData.applyWay) },
          }),
          _vm._v(" "),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tabActive == "大赛介绍",
                expression: "tabActive == '大赛介绍'",
              },
            ],
            domProps: { innerHTML: _vm._s(_vm.matchData.introduce) },
          }),
          _vm._v(" "),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tabActive == "大赛规则",
                expression: "tabActive == '大赛规则'",
              },
            ],
            domProps: { innerHTML: _vm._s(_vm.matchData.rule) },
          }),
          _vm._v(" "),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tabActive == "大赛奖励",
                expression: "tabActive == '大赛奖励'",
              },
            ],
            domProps: { innerHTML: _vm._s(_vm.matchData.award) },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.tabActive == "参赛作品",
                  expression: "tabActive == '参赛作品'",
                },
              ],
              staticClass: "worksListBox",
            },
            [
              _vm.worksList.length
                ? _c(
                    "div",
                    { staticClass: "worksListBox_box" },
                    [
                      _vm._l(_vm.worksList, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "match_works",
                            on: {
                              click: function ($event) {
                                return _vm.$router.push(`matchWorks/${item.id}`)
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "works_cover",
                              attrs: {
                                src: item.cover
                                  ? item.cover
                                  : item.workPictureList[0],
                                alt: "",
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "works_info" }, [
                              _c("img", {
                                staticClass: "user_avatar",
                                attrs: { src: item.authorAvatar, alt: "" },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "user_authorName" }, [
                                _vm._v(_vm._s(item.authorName)),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "works_name" }, [
                                _vm._v(_vm._s(item.name)),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c("el-pagination", {
                        attrs: {
                          background: "",
                          layout: "total, prev, pager, next",
                          total: _vm.totalElements,
                          "page-size": 8,
                        },
                        on: { "current-change": _vm.changePagination },
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.worksList.length
                ? _c("span", { staticClass: "default" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/icon/notdata.png"),
                        alt: "",
                      },
                    }),
                    _vm._v(
                      "\n                    暂时没有相关数据\n                "
                    ),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _vm.tabActive == "作品上传" &&
          _vm.userInfo &&
          JSON.stringify(_vm.userInfo) != "{}"
            ? _c(
                "div",
                [
                  !_vm.signUpSuccess
                    ? _c(
                        "el-form",
                        {
                          ref: "ruleForm",
                          staticClass: "demo-ruleForm",
                          attrs: {
                            model: _vm.ruleForm,
                            rules: _vm.rules,
                            size: "medium",
                            "label-width": "100px",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "赛项", prop: "matchItemId" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择参赛赛项" },
                                  on: { change: _vm.handlerMatchItem },
                                  model: {
                                    value: _vm.ruleForm.matchItemId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "matchItemId", $$v)
                                    },
                                    expression: "ruleForm.matchItemId",
                                  },
                                },
                                _vm._l(_vm.matchItem, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "组别",
                                prop: "matchItemGroupId",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: !_vm.ruleForm.matchItemId,
                                    placeholder: "请选择参赛组别",
                                  },
                                  model: {
                                    value: _vm.ruleForm.matchItemGroupId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "matchItemGroupId",
                                        $$v
                                      )
                                    },
                                    expression: "ruleForm.matchItemGroupId",
                                  },
                                },
                                _vm._l(
                                  _vm.matchItemGroup,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.id,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "名称", prop: "name" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请填写作品名称" },
                                model: {
                                  value: _vm.ruleForm.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "name", $$v)
                                  },
                                  expression: "ruleForm.name",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "视频", prop: "workVideoUrl" } },
                            [
                              _c(
                                "el-upload",
                                {
                                  attrs: {
                                    action: _vm.avatarUploadUrl,
                                    drag: "",
                                    headers: _vm.headers,
                                    limit: 1,
                                    "before-upload": _vm.beforeVideoUpload,
                                    "on-success": _vm.handlerVideoSuccess,
                                    "on-remove": _vm.handleRemove,
                                  },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-upload" }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "el-upload__text" },
                                    [
                                      _vm._v("将视频文件拖到此处，或"),
                                      _c("em", [_vm._v("点击上传")]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "el-upload__tip",
                                      attrs: { slot: "tip" },
                                      slot: "tip",
                                    },
                                    [
                                      _vm._v(
                                        "只能上传一个视频文件，且不超过500MB"
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "图片", prop: "workPictureList" },
                            },
                            [
                              _c("CardUpload", {
                                on: { change: _vm.changeImg },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "说明文档：",
                                prop: "documentUrls",
                              },
                            },
                            [
                              _c("clickUpload", {
                                ref: "docUploader",
                                attrs: {
                                  limit: 3,
                                  listType: "text",
                                  drag: true,
                                  uploadSize: 50,
                                  accept: ".doc, .docx, .pdf, .ppt, .pptx",
                                  uploadPath: `/uploadCourseware`,
                                  noticeText:
                                    "只能上传doc/docx/pdf/ppt/pptx文件，且不超过50MB",
                                },
                                on: {
                                  change: _vm.docsUpload,
                                  removed: _vm.removeDoc,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c("loadingBtn", {
                                attrs: { btnText: "提交" },
                                on: {
                                  click: function ($event) {
                                    return _vm.submitForm("ruleForm")
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c("div", { staticClass: "signUpSuccess" }, [
                        _c("div", { staticClass: "signUpSuccessTitle" }, [
                          _vm._v("恭喜您，参赛成功"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "signUpSuccessFooter" },
                          [
                            _c(
                              "el-link",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    _vm.signUpSuccess = false
                                  },
                                },
                              },
                              [_vm._v("继续报名")]
                            ),
                          ],
                          1
                        ),
                      ]),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/match/matchDetail.vue?vue&type=template&id=3a721efc&
// module id = null
// module chunks = 